import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type ContentStage = 'video' | 'quiz' | 'result'

interface QuizAnswer {
  questionId: string
  answer: string
}

interface StudyState {
  currentStage: ContentStage
  currentScore: number
  answers: QuizAnswer[]
  studyHistory: {
    [key: string]: {
      score: number
      completedAt: string
    }
  }

  setStage: (stage: ContentStage) => void
  setScore: (score: number) => void
  saveAnswer: (questionId: string, answer: string) => void
  calculateScore: () => number
  saveStudyResult: (levelId: string, score: number) => void
  goToNextStage: () => void
}

export const useStudyStore = create<StudyState>()(
  persist(
    (set, get) => ({
      currentStage: 'video',
      currentScore: 0,
      answers: [],
      studyHistory: {},

      setStage: (stage) => set({ currentStage: stage }),

      setScore: (score) => set({ currentScore: score }),

      saveAnswer: (questionId, answer) =>
        set((state) => {
          const existingAnswerIndex = state.answers.findIndex(
            (a) => a.questionId === questionId
          )

          if (existingAnswerIndex !== -1) {
            const newAnswers = [...state.answers]
            newAnswers[existingAnswerIndex] = { questionId, answer }
            return { answers: newAnswers }
          } else {
            return { answers: [...state.answers, { questionId, answer }] }
          }
        }),

      calculateScore: () => {
        // 실제로는 정답과 비교하는 로직 필요
        const answers = get().answers

        // 임시 정답 데이터
        const correctAnswers: { [key: string]: string } = {
          q1: '3',
          q2: '8',
          q3: '2',
        }

        let correctCount = 0
        answers.forEach((a) => {
          if (correctAnswers[a.questionId] === a.answer) {
            correctCount++
          }
        })

        const score = Math.round(
          (correctCount / Object.keys(correctAnswers).length) * 100
        )
        return score
      },

      saveStudyResult: (levelId, score) =>
        set((state) => ({
          studyHistory: {
            ...state.studyHistory,
            [levelId]: {
              score,
              completedAt: new Date().toISOString(),
            },
          },
        })),

      goToNextStage: () =>
        set((state) => {
          if (state.currentStage === 'video') {
            return { currentStage: 'quiz' }
          } else if (state.currentStage === 'quiz') {
            const score = get().calculateScore()
            return { currentStage: 'result', currentScore: score }
          }
          return {}
        }),
    }),
    {
      name: 'study-storage',
      partialize: (state) => ({
        studyHistory: state.studyHistory,
      }),
    }
  )
)
